import { DateTime } from "luxon";

// Design (21) CLAUDE.md "Member approval date" and CMP Dashboard.dc.html
// :15608-15612: the Member Approval row shows "Approved on <date>" beside the
// green Approved tag. CAP stores the approval time (boardApprovedAtUtcMilli);
// records approved before it was stored fall back to the join date.
export const getMemberApprovedOnDate = ({
  approvedAtUtcMilli,
  joinedAtUtcMilli,
  timeZone,
}: {
  approvedAtUtcMilli?: number | null;
  joinedAtUtcMilli?: number | null;
  timeZone: string;
}): string | null => {
  const value = approvedAtUtcMilli || joinedAtUtcMilli;
  return value
    ? DateTime.fromMillis(value, { zone: timeZone }).toFormat("MMM d, yyyy", { locale: "en-US" })
    : null;
};
